/*--------------
V 1.0.0 - Criado por Larner Diogo
DESCIÇÃO:
Modulo geral da Aplicação
COMPONENTS
***********************************************************/
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { TooltipModule } from 'ngx-bootstrap';
import { MatAutocompleteModule, MatInputModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms'
import { NgSelectModule } from '@ng-select/ng-select';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ModalModule } from 'ngx-bootstrap/modal';

/**********************************************************
PROVIDERS
***********************************************************/
import { GuardService } from './globals/guard';
import { SessionService } from './globals/session';
import { StorageService } from './globals/storage';
import { HttpService } from './globals/http';
import { GlobalService } from './globals/globals';
import { SharedService } from './shared/shared.service';
import {RelatoriosService} from './authorization/cursos/relatorios/relatorios.service'

/**********************************************************
PAGES
***********************************************************/
import { AppComponent } from './app.component';
import { NoAuthorizationComponent } from './no-authorization/index';
import { AuthorizationComponent } from './authorization/index';

/**********************************************************
ROUTER
***********************************************************/
import { AppRoutingModule } from './app.routing';

/**********************************************************
SHAREDS
***********************************************************/
import { AppHeaderComponent } from './shared/app-header/index';
import { AppSidebarComponent } from './shared/app-sidebar/index';
// import { AppBreadcrumbsComponent } from './shared/app-breadcrumbs/index';
import { AppAsideComponent } from './shared/app-aside/index';
import { AppFooterComponent } from './shared/app-footer/index';
import { AppSidebarFooterComponent } from './shared/app-sidebar-footer/index';
import { AppSidebarFormComponent } from './shared/app-sidebar-form/index';
import { AppSidebarHeaderComponent } from './shared/app-sidebar-header/index';
import { AppSidebarMinimizerComponent } from './shared/app-sidebar-minimizer/index';
import { APP_SIDEBAR_NAV } from './shared/app-sidebar-nav/index';

/**********************************************************
DIRETIVAS
***********************************************************/
import { AsideToggleDirective, NAV_DROPDOWN_DIRECTIVES, ReplaceDirective, SIDEBAR_TOGGLE_DIRECTIVES } from './directives/index';
import { ExcelService } from './utils/excel.service';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ToastrModule.forRoot(),
    ChartsModule,
    CommonModule,
    HttpClientModule,
    HttpModule,
    NgxPaginationModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    NgSelectModule,
  ],
  declarations: [
    AppComponent,
    NoAuthorizationComponent,
    AuthorizationComponent,
    AppHeaderComponent,
    AppSidebarComponent,
    // AppBreadcrumbsComponent,
    AppAsideComponent,
    AppFooterComponent,
    AppSidebarFooterComponent,
    AppSidebarFormComponent,
    AppSidebarHeaderComponent,
    AppSidebarMinimizerComponent,
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES,
    APP_SIDEBAR_NAV
    
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    HttpModule,
    GuardService,
    SessionService,
    StorageService,
    HttpService,
    GlobalService,
    SharedService,
    RelatoriosService,
    ExcelService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [ AppComponent ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts